import React from 'react';
import './GameStats.css';

interface GameStatsProps {
  revealedCount: number;
  totalLetters: number;
  score: number;
  gameOver: boolean;
  letterGuessesLeft?: number;
  maxLetterGuesses?: number;
}

function GameStats({ 
  revealedCount, 
  totalLetters, 
  score, 
  gameOver,
  letterGuessesLeft = 6,
  maxLetterGuesses = 6
}: GameStatsProps) {
  return (
    <div className="game-stats">      
      <div className="stat-item">
        <span className="stat-label">Revealed Letters:</span>
        <span className="stat-value">{revealedCount} / {totalLetters}</span>
      </div>
      
      <div className="stat-item">
        <span className="stat-label">Letter Guesses Left:</span>
        <span className="stat-value">{letterGuessesLeft} / {maxLetterGuesses}</span>
      </div>
      
      {gameOver && (
        <div className="stat-item score">
          <span className="stat-label">Final Score:</span>
          <span className="stat-value">{score}</span>
        </div>
      )}
    </div>
  );
}

export default GameStats;
